import { render, staticRenderFns } from "./ProjectAttributes.vue?vue&type=template&id=95c56a90&scoped=true"
import script from "./ProjectAttributes.vue?vue&type=script&lang=ts"
export * from "./ProjectAttributes.vue?vue&type=script&lang=ts"
import style0 from "./ProjectAttributes.vue?vue&type=style&index=0&id=95c56a90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c56a90",
  null
  
)

export default component.exports